module.exports = __webpack_public_path__ + "static/media/FigmaSecurity.36991755.png";